import { Reveal } from "../site/Reveal";
import { BarChart3, Timer, Zap, AlertCircle } from "lucide-react";
import { useT } from "@/i18n/useLocale";

const ICONS = [BarChart3, Timer, Zap, AlertCircle];

export function MetricasFacturas() {
  const t = useT();
  const m = t.facturas.metricas;

  return (
    <section className="border-t border-hairline bg-background py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="mb-3 text-xs uppercase tracking-[0.18em] text-ink-soft/70">{m.eyebrow}</p>
          <h2 className="font-display max-w-3xl text-4xl leading-[1.05] tracking-tight text-ink sm:text-5xl">
            {m.title}
          </h2>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-soft">{m.intro}</p>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {m.items.map((it, i) => {
            const Icon = ICONS[i] ?? BarChart3;
            return (
              <Reveal key={it.v} delay={i * 0.06}>
                <div className="flex h-full flex-col rounded-2xl border border-hairline bg-surface p-6">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="font-display mt-5 text-lg leading-tight tracking-tight text-ink">
                    {it.v}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-soft">{it.l}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
